import AuthService from '../services/AuthService';
import { seesRevenue } from './roles';

/** Whether the signed-in user sees revenue in Analytics. */
export function viewerSeesRevenue() {
  return seesRevenue(AuthService.getUser()?.role);
}
